import type { Point } from "@incytestudios/ddv";
import type {
  MLETemperatureChartContext,
  MLETemperatureChartDataSet
} from "./d";
import {
  getMaxCurrentAtTemperatureA,
  getCableMaxTemperatureF
} from "../../calculations/cables";

export const getMLETemperatureDataset = (
  context: MLETemperatureChartContext
): MLETemperatureChartDataSet => {
  const {
    maxTemp,
    minTemp,
    targetTempUnit,
    downholeTempAtCableEndF,
    motorCurrentA,
    ampFactor,
    mleLabel
  } = context;

  const loops = 20;
  const tempPerStep = (maxTemp - minTemp) / loops;
  const points: Point[] = [];

  for (let temp = minTemp; temp <= maxTemp; temp += tempPerStep) {
    if (motorCurrentA === 0) break;

    const xValue = targetTempUnit.toThisUnit(temp);
    const yValue = getMaxCurrentAtTemperatureA(maxTemp, temp, ampFactor);

    if (xValue >= 0) {
      points.push({
        x: xValue,
        y: yValue
      });
    }
  }

  const operatingAmp = motorCurrentA;
  const xOperatingPoint = getCableMaxTemperatureF(
    ampFactor,
    operatingAmp,
    downholeTempAtCableEndF
  );

  const maxAmpsAtTemp = getMaxCurrentAtTemperatureA(
    maxTemp,
    xOperatingPoint,
    ampFactor
  );
  const loadRatio = maxAmpsAtTemp > 0 ? operatingAmp / maxAmpsAtTemp : 1;

  return {
    title: mleLabel,
    xAxisLabel: `Temperature (${
      targetTempUnit.shortLabel || targetTempUnit.label
    })`,
    yAxisLabel: "Load (A)",
    operatingPoint: {
      label: mleLabel,
      xLabel: `Temp ${targetTempUnit.shortLabel}`,
      point: {
        x: targetTempUnit.toThisUnit(xOperatingPoint),
        y: operatingAmp
      }
    },
    loadRatio,
    points
  };
};
